// KHO VIDEO — tiện ích + các HỘP THOẠI nhỏ (06/10/2026): đọc thông số / ảnh đại diện của video ngay trên trình duyệt, Sửa mô tả, Gắn nhãn, Xem trước, Đăng ngay…
// Dùng chung trang Kho video và nút "Đăng video thử ngay" ở hộp Lệnh. Mọi chữ dựng bằng textContent (h()). Nút ≥ 40 px, trạng thái bằng chữ + màu.
import { api, buildQuery, errMsg } from "../api";
import { busy, clear, h, toast } from "../dom";
import { loadBots } from "../store";
import { nhanBotTat } from "../format";
import type { Bot } from "../types";
import { chuThoiLuong, chuanHashtag, ghiHashtag, HASHTAG_TOI_DA, MO_TA_TOI_DA, NHAN_KIEU_DANG, TEN_NEN_TANG_VIDEO, TIEU_DE_TOI_DA, type NenTangVideo } from "../../../../src/shared/video-kho";
import { phanChon } from "./video-chon-nut";

export interface VideoWeb {
  id: string; ownerId: string; ownerName: string | null; tenTep: string; tieuDe: string; moTa: string; hashtag: string[]; nhan: string[]; mime: string; kichThuoc: number;
  thoiLuong: number | null; rong: number | null; cao: number | null; tiLe: "doc" | "ngang" | "vuong" | null; coHinh: boolean; taoLuc: string; suaLuc: string;
  /** null khi tệp đã xoá khỏi máy chủ (Tự xoá tệp sau khi đăng). */
  urlTep: string | null; urlHinh: string | null; kieu: { facebook: string; youtube: string; tiktok: string };
  daXoaTep: boolean; daXoaTepLuc: string | null; giuNhieuBot: boolean;
  daDang: { nenTang: string; botId: string; botTen: string | null; trangThai: string; luc: string; url: string | null }[];
  soBotDaDang: number; trangThaiDang: "chua_dang" | "da_dang" | "het_luot";
}

export const mbChu = (n: number): string => (n >= 1073741824 ? `${(n / 1073741824).toFixed(1)} GB` : n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${n > 0 ? Math.max(1, Math.round(n / 1024)) : 0} KB`);

export interface ThongSoVideoWeb { thoiLuong: number | null; rong: number | null; cao: number | null; hinh: string | null }

/** Đọc thời lượng + khung hình + ảnh đại diện (JPEG nhỏ) của một tệp video ngay trên trình duyệt. Không đọc được (codec lạ…) → null từng phần; không bao giờ ném / treo quá hạn. */
export async function docVideoWeb(f: File, hanMs = 12_000): Promise<ThongSoVideoWeb> {
  const kq: ThongSoVideoWeb = { thoiLuong: null, rong: null, cao: null, hinh: null };
  const url = URL.createObjectURL(f);
  const v = document.createElement("video");
  v.muted = true; v.preload = "metadata"; v.playsInline = true;
  const doi = <T,>(ev: string, ms: number): Promise<boolean> => new Promise((res) => { const t = setTimeout(() => res(false), ms); v.addEventListener(ev, () => { clearTimeout(t); res(true); }, { once: true }); v.addEventListener("error", () => { clearTimeout(t); res(false); }, { once: true }); });
  try {
    v.src = url;
    if (!(await doi("loadedmetadata", hanMs))) return kq;
    if (Number.isFinite(v.duration) && v.duration > 0) kq.thoiLuong = Math.round(v.duration * 1000) / 1000;
    if (v.videoWidth > 0 && v.videoHeight > 0) { kq.rong = v.videoWidth; kq.cao = v.videoHeight; }
    if (kq.rong && kq.cao) {
      try {
        const dich = Math.min(1, v.duration / 2);
        const xong = doi("seeked", 6000);
        v.currentTime = dich;
        if (await xong) {
          const k = Math.min(1, 320 / Math.max(kq.rong, kq.cao));
          const cv = document.createElement("canvas");
          cv.width = Math.max(1, Math.round(kq.rong * k)); cv.height = Math.max(1, Math.round(kq.cao * k));
          cv.getContext("2d")?.drawImage(v, 0, 0, cv.width, cv.height);
          const d = cv.toDataURL("image/jpeg", 0.72);
          if (d.startsWith("data:image/jpeg") && d.length < 380_000) kq.hinh = d;
        }
      } catch { /* không lấy được ảnh đại diện — vẫn dùng thông số */ }
    }
  } finally { v.removeAttribute("src"); v.load(); URL.revokeObjectURL(url); }
  return kq;
}

// ---------------- khung hộp thoại ----------------
function khungHop(tieuDe: string, testid: string, noi: HTMLElement[], chan: HTMLElement[], dong: () => void): HTMLElement {
  const wrap = h("div", { class: "modal-wrap", role: "dialog", "aria-modal": "true", "aria-label": tieuDe, "data-testid": testid },
    h("div", { class: "modal kv-hop" }, h("h3", {}, tieuDe), ...noi, h("div", { class: "row end kv-hop-chan" }, ...chan)));
  wrap.addEventListener("keydown", (e) => { if (e.key === "Escape") { e.stopPropagation(); dong(); } });
  wrap.addEventListener("dong-hop", () => dong());
  document.body.append(wrap);
  return wrap;
}
const nutHuy = (testid: string, chu = "Đóng"): HTMLButtonElement => h("button", { type: "button", class: "kv-nut", "data-testid": testid, title: chu === "Đóng" ? "Đóng hộp này" : "Bỏ, không đổi gì" }, chu);

// ---------------- Sửa mô tả ----------------
export function moHopSua(v: VideoWeb): Promise<VideoWeb | null> {
  return new Promise((resolve) => {
    let xong = false;
    const ket = (r: VideoWeb | null): void => { if (xong) return; xong = true; wrap.remove(); resolve(r); };
    const tieu = h("input", { value: v.tieuDe, maxlength: TIEU_DE_TOI_DA, "data-testid": "kv-sua-tieu-de", "aria-label": "Tiêu đề video", autocomplete: "off" });
    const moTa = h("textarea", { rows: 6, maxlength: MO_TA_TOI_DA, "data-testid": "kv-sua-mo-ta", "aria-label": "Mô tả video" }); moTa.value = v.moTa;
    const tag = h("input", { value: ghiHashtag(v.hashtag), "data-testid": "kv-sua-hashtag", "aria-label": "Hashtag", placeholder: "#dựng3d #mẹohay", autocomplete: "off" });
    const loi = h("div", { class: "err-box", hidden: true, role: "alert", "data-testid": "kv-sua-loi" });
    const dem = h("span", { class: "small muted" }, "");
    const capNhat = (): void => { dem.textContent = `Tiêu đề ${Array.from(tieu.value).length}/${TIEU_DE_TOI_DA} · Mô tả ${Array.from(moTa.value).length}/${MO_TA_TOI_DA} · ${chuanHashtag(tag.value).length}/${HASHTAG_TOI_DA} hashtag`; };
    for (const e of [tieu, moTa, tag]) e.addEventListener("input", capNhat);
    capNhat();
    const luu = h("button", { type: "button", class: "kv-nut pri", "data-testid": "kv-sua-luu", title: "Lưu tiêu đề, mô tả và hashtag của video" }, "Lưu");
    const huy = nutHuy("kv-sua-huy", "Huỷ");
    huy.addEventListener("click", () => ket(null));
    luu.addEventListener("click", () => void busy(luu, "Đang lưu…", async () => {
      loi.hidden = true;
      if (!tieu.value.trim()) { loi.textContent = "Tiêu đề không được để trống"; loi.hidden = false; tieu.focus(); return; }
      try { const r = await api<VideoWeb>("PUT", `/api/kho-video/${encodeURIComponent(v.id)}`, { tieuDe: tieu.value, moTa: moTa.value, hashtag: tag.value }); toast("Đã lưu mô tả video", "info", 1800); ket(r); }
      catch (e) { loi.textContent = `Chưa lưu được: ${errMsg(e)}`; loi.hidden = false; }
    }));
    const wrap = khungHop("Sửa mô tả video", "kv-hop-sua", [
      h("p", { class: "small muted" }, "Chữ này bot dùng khi đăng (tiêu đề, mô tả, hashtag). Mỗi bot có thể được AI viết lại để không đăng cùng một chữ."),
      h("label", { class: "f" }, h("span", {}, "Tiêu đề"), tieu), h("label", { class: "f" }, h("span", {}, "Mô tả"), moTa), h("label", { class: "f" }, h("span", {}, "Hashtag"), tag), dem, loi,
    ], [huy, luu], () => ket(null));
    tieu.focus();
  });
}

// ---------------- Gắn nhãn ----------------
export function moHopNhan(v: VideoWeb, nhanCo: string[]): Promise<VideoWeb | null> {
  return new Promise((resolve) => {
    let xong = false;
    const ket = (r: VideoWeb | null): void => { if (xong) return; xong = true; wrap.remove(); resolve(r); };
    const chon = new Set(v.nhan);
    const chip = h("div", { class: "kv-chip-ds", "data-testid": "kv-nhan-ds" });
    const moi = h("input", { placeholder: "Nhãn mới, ví dụ: khuyến mãi", maxlength: 40, "data-testid": "kv-nhan-moi", "aria-label": "Nhãn mới", autocomplete: "off" });
    const loi = h("div", { class: "err-box", hidden: true, role: "alert", "data-testid": "kv-nhan-loi" });
    const veChip = (): void => {
      clear(chip);
      const tatCa = [...new Set([...nhanCo, ...chon])];
      if (!tatCa.length) chip.append(h("span", { class: "small muted" }, "Chưa có nhãn nào — gõ nhãn mới bên dưới rồi bấm Thêm."));
      for (const n of tatCa) {
        const b = h("button", { type: "button", class: `kv-chip${chon.has(n) ? " chon" : ""}`, role: "checkbox", "aria-checked": String(chon.has(n)), "data-testid": "kv-nhan-chip", title: "Bật / tắt nhãn này cho video", dataset: { nhan: n } }, chon.has(n) ? "✓ " : "", n);
        b.addEventListener("click", () => { if (chon.has(n)) chon.delete(n); else chon.add(n); veChip(); });
        chip.append(b);
      }
    };
    veChip();
    const them = h("button", { type: "button", class: "kv-nut", "data-testid": "kv-nhan-them", title: "Thêm nhãn vừa gõ vào danh sách" }, "Thêm");
    const themNhan = (): void => { const t = moi.value.replace(/[,"{}]/g, " ").replace(/\s+/g, " ").trim(); if (!t) return; chon.add(Array.from(t).slice(0, 40).join("")); moi.value = ""; veChip(); };
    them.addEventListener("click", themNhan);
    moi.addEventListener("keydown", (e) => { if (e.key === "Enter") { e.preventDefault(); themNhan(); } });
    const luu = h("button", { type: "button", class: "kv-nut pri", "data-testid": "kv-nhan-luu", title: "Lưu các nhãn đã bật cho video" }, "Lưu nhãn");
    const huy = nutHuy("kv-nhan-huy", "Huỷ");
    huy.addEventListener("click", () => ket(null));
    luu.addEventListener("click", () => void busy(luu, "Đang lưu…", async () => {
      themNhan();
      loi.hidden = true;
      try { const r = await api<VideoWeb>("PUT", `/api/kho-video/${encodeURIComponent(v.id)}`, { nhan: [...chon] }); toast("Đã lưu nhãn", "info", 1800); ket(r); }
      catch (e) { loi.textContent = `Chưa lưu được: ${errMsg(e)}`; loi.hidden = false; }
    }));
    const wrap = khungHop("Gắn nhãn cho video", "kv-hop-nhan", [
      h("p", { class: "small muted" }, "Nhãn giúp mỗi bot / mỗi kịch bản chỉ đăng một nhóm video (chọn “Theo nhãn” ở bước Đăng video). Bấm nhãn để bật / tắt."),
      chip, h("div", { class: "row kv-nhan-hang" }, moi, them), loi,
    ], [huy, luu], () => ket(null));
    moi.focus();
  });
}

// ---------------- Xem trước ----------------
export function moHopXem(v: VideoWeb): Promise<void> {
  return new Promise((resolve) => {
    if (!v.urlTep) { toast("Tệp video đã xoá khỏi máy chủ sau khi đăng — bấm “Tải lên lại tệp” nếu muốn xem / đăng lại", "warn"); resolve(); return; }
    const ket = (): void => { vid.pause(); vid.removeAttribute("src"); vid.load(); wrap.remove(); resolve(); };
    const vid = h("video", { controls: true, preload: "metadata", playsinline: true, class: "kv-xem-video", "data-testid": "kv-xem-video", "aria-label": `Xem trước: ${v.tieuDe}` });
    vid.src = v.urlTep ?? "";
    const loi = h("div", { class: "err-box", hidden: true, role: "alert", "data-testid": "kv-xem-loi" });
    vid.addEventListener("error", () => { loi.textContent = "Trình duyệt không phát được video này (có thể do định dạng) — video vẫn đăng bình thường."; loi.hidden = false; });
    const dong = nutHuy("kv-xem-dong");
    dong.addEventListener("click", ket);
    const wrap = khungHop(v.tieuDe || v.tenTep, "kv-hop-xem", [vid, loi, h("p", { class: "small muted" }, [chuThoiLuong(v.thoiLuong), v.rong && v.cao ? v.rong + "×" + v.cao : "chưa rõ khung hình", mbChu(v.kichThuoc)].join(" · "))], [dong], ket);
    dong.focus();
  });
}

// ---------------- Đăng ngay… ----------------
type BotMini = Bot;
/** Hộp "Đăng ngay…": chọn (video nếu chưa có), bot, nền tảng, chế độ → tạo kịch bản một bước ghim video (đi qua cổng Chạy thử → Chạy thật như mọi kịch bản). Trả đường dẫn kịch bản hoặc null. */
export function moHopDangNgay(o: { video?: VideoWeb; dsVideo?: VideoWeb[]; ownerId?: string | null }): Promise<string | null> {
  return new Promise((resolve) => {
    let xong = false;
    const ket = (r: string | null): void => { if (xong) return; xong = true; wrap.remove(); resolve(r); };
    let video: VideoWeb | undefined = o.video;
    let chonVideoXong: () => void = () => {};
    let botId = "", nenTang: NenTangVideo = "youtube", cheDo = "thu";
    const thanVideo = h("div", { "data-testid": "kv-dn-video-hop" });
    const botBox = h("div", { "data-testid": "kv-dn-bot-hop" });
    const ntBox = h("div", { "data-testid": "kv-dn-nt-hop" });
    const cdBox = h("div", { "data-testid": "kv-dn-cd-hop" });
    const canhBao = h("div", { class: "warn-box", hidden: true, "data-testid": "kv-dn-canh-bao", role: "note" });
    const goiY = h("p", { class: "small muted", "data-testid": "kv-dn-goi-y" });
    const loi = h("div", { class: "err-box", hidden: true, role: "alert", "data-testid": "kv-dn-loi" });
    const tao = h("button", { type: "button", class: "kv-nut pri", "data-testid": "kv-dn-tao", title: "Tạo kịch bản một bước đăng video này (riêng tư nếu để Thử) rồi mở nó" }, "Tạo việc đăng");
    const huy = nutHuy("kv-dn-huy", "Huỷ");
    huy.addEventListener("click", () => ket(null));
    const veGoiY = (): void => {
      const k = video ? (video.kieu as Record<string, string>)[nenTang] : "";
      goiY.textContent = video ? `Video “${video.tieuDe}” sẽ đăng lên ${TEN_NEN_TANG_VIDEO[nenTang]} dạng ${NHAN_KIEU_DANG[k as keyof typeof NHAN_KIEU_DANG] ?? k}.` : "Chọn video trước.";
      canhBao.hidden = cheDo !== "cong_khai";
      canhBao.textContent = cheDo === "cong_khai" ? "Công khai: bài sẽ hiện cho mọi người. Nên thử ở chế độ Riêng tư trước. Bước này sẽ chờ bạn duyệt trước khi bấm Đăng." : "";
      tao.disabled = !video || !botId;
    };
    const veNen = (): void => {
      clear(ntBox);
      ntBox.append(phanChon({ ten: "Nền tảng", testid: "kv-dn-nt", ds: (["youtube", "facebook", "tiktok"] as const).map((n) => ({ v: n, nhan: TEN_NEN_TANG_VIDEO[n] })), giaTri: nenTang, onDoi: (v) => { nenTang = v as NenTangVideo; veGoiY(); } }));
      clear(cdBox);
      cdBox.append(phanChon({ ten: "Chế độ", testid: "kv-dn-cd", ds: [{ v: "thu", nhan: "Thử (riêng tư)", goiY: "Chỉ mình bạn xem — để kiểm tra trước khi công khai" }, { v: "cong_khai", nhan: "Công khai" }], giaTri: cheDo, onDoi: (v) => { cheDo = v; veGoiY(); } }));
    };
    const veVideo = (): void => {
      clear(thanVideo);
      if (o.video) { thanVideo.append(h("p", { class: "kv-dn-tom-tat", "data-testid": "kv-dn-video-ten" }, h("b", {}, o.video.tieuDe || o.video.tenTep), ` · ${chuThoiLuong(o.video.thoiLuong)} · ${mbChu(o.video.kichThuoc)}`)); return; }
      const sel = h("select", { "data-testid": "kv-dn-video", "aria-label": "Chọn video" }, h("option", { value: "" }, "— Chọn video trong kho —"), ...(o.dsVideo ?? []).map((x) => h("option", { value: x.id }, `${x.tieuDe || x.tenTep} (${chuThoiLuong(x.thoiLuong)})`)));
      sel.addEventListener("change", () => { video = (o.dsVideo ?? []).find((x) => x.id === sel.value); veGoiY(); chonVideoXong(); });
      thanVideo.append(sel);
    };
    const wrap = khungHop("Đăng video", "kv-hop-dang-ngay", [
      h("p", { class: "small muted" }, "Bot sẽ đăng video này MỘT lần. Mặc định ở chế độ Riêng tư để bạn kiểm tra trước. Việc đăng đi qua các bước an toàn sẵn có (bấm ▶ Chạy, bước đăng dừng chờ bạn duyệt)."),
      h("div", { class: "kv-dn-muc" }, h("h4", {}, "1. Video nào?"), thanVideo),
      h("div", { class: "kv-dn-muc" }, h("h4", {}, "2. Bot nào đăng?"), botBox),
      h("div", { class: "kv-dn-muc" }, h("h4", {}, "3. Đăng lên đâu?"), ntBox),
      h("div", { class: "kv-dn-muc" }, h("h4", {}, "4. Chế độ"), cdBox), canhBao, goiY, loi,
    ], [huy, tao], () => ket(null));
    veVideo(); veNen(); veGoiY();
    // Bot CHỈ của chủ video đã chọn (Super thấy bot nhiều chủ; đăng video của A bằng bot của B bị máy chủ từ chối) — vẽ lại khi đổi video.
    let tatCaBot: BotMini[] | null = null;
    let loiBot = "";
    const veBot = (): void => {
      clear(botBox);
      if (loiBot) { botBox.append(h("p", { class: "err" }, `Không tải được danh sách bot: ${loiBot}`)); return; }
      if (!tatCaBot) return;
      if (!video && !o.video) { botBox.append(h("p", { class: "small muted", "data-testid": "kv-dn-chon-video-truoc" }, "Chọn video trước — chỉ hiện bot của chủ video đó.")); botId = ""; veGoiY(); return; }
      const chu = (video ?? o.video)!.ownerId;
      const bots = tatCaBot.filter((b) => b.ownerId === chu);
      if (!bots.length) { botBox.append(h("p", { class: "warn", "data-testid": "kv-dn-khong-bot" }, "Chủ video này chưa có bot nào. Ghép bot ở trang Bot rồi quay lại.")); botId = ""; veGoiY(); return; }
      if (!bots.some((b) => b.id === botId)) botId = bots[0]!.id;
      const ds = bots.map((b) => ({ v: b.id, nhan: nhanBotTat(b) }));
      botBox.append(ds.length > 5
        ? (() => { const sel = h("select", { "data-testid": "kv-dn-bot", "aria-label": "Chọn bot" }, ...ds.map((d) => h("option", { value: d.v, selected: d.v === botId }, d.nhan))); sel.addEventListener("change", () => { botId = sel.value; veGoiY(); }); return sel; })()
        : phanChon({ ten: "Bot", testid: "kv-dn-bot", ds, giaTri: botId, onDoi: (v) => { botId = v; veGoiY(); } }));
      veGoiY();
    };
    chonVideoXong = veBot;
    void (async () => {
      try { tatCaBot = await loadBots(); } catch (e) { loiBot = errMsg(e); }
      veBot();
    })();
    tao.addEventListener("click", () => void busy(tao, "Đang tạo…", async () => {
      loi.hidden = true;
      if (!video || !botId) return;
      try {
        const r = await api<{ kichBanId: string; ten: string; duongDan: string; daCo: boolean }>("POST", `/api/kho-video/${encodeURIComponent(video.id)}/dang-ngay`, { botId, nenTang, cheDo });
        toast(r.daCo ? "Việc đăng này đã có sẵn — mở lại" : "Đã tạo việc đăng — bấm ▶ Chạy", "info", 3500);
        ket(r.duongDan);
      } catch (e) { loi.textContent = errMsg(e); loi.hidden = false; }
    }));
  });
}

/** Tải danh sách video (cho ô chọn video của hộp Đăng ngay ở nơi ngoài trang Kho video). */
export async function taiDsVideo(ownerId?: string | null): Promise<VideoWeb[]> {
  const r = await api<{ items: VideoWeb[] }>("GET", `/api/kho-video${buildQuery({ limit: 100, ownerId: ownerId ?? null })}`);
  return r.items.filter((x) => !x.daXoaTep); // video đã xoá tệp sau khi đăng không còn đăng được (cần tải lên lại)
}
